import { Link } from 'react-router-dom';
import {
  ADDRESS,
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  COMPANY_NAME,
  FOOTER_DISCLAIMER,
  SITE_DOMAIN,
  SITE_NAME,
  SUPPORT_EMAIL,
} from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="shell footer__grid">
        <div>
          <p className="footer__brand">{SITE_NAME}</p>
          <p className="footer__text">
            Independent support for downloads, sync, TreeVault, and migration at {SITE_DOMAIN}.
          </p>
          <div className="footer__actions">
            <button type="button" className="btn btn--light" onClick={openZohoChat}>
              Live Chat
            </button>
          </div>
        </div>

        <div>
          <h3 className="footer__heading">Pages</h3>
          <ul className="footer__list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/#features">Features</Link></li>
            <li><Link to="/#getting-started">Getting Started</Link></li>
            <li><Link to="/#requirements">System Requirements</Link></li>
            <li><Link to="/#faq">FAQ</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="footer__heading">Legal</h3>
          <ul className="footer__list">
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/terms-of-service">Terms of Service</Link></li>
            <li><Link to="/refund-policy">Refund Policy</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="footer__heading">Contact</h3>
          <ul className="footer__list footer__list--contact">
            <li><a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></li>
            <li>{COMPANY_NAME}</li>
            <li>{ADDRESS_LINE1}</li>
            <li>{ADDRESS_LINE2}</li>
          </ul>
        </div>
      </div>

      <div className="shell footer__bottom">
        <p>&copy; 2026 {SITE_NAME}. All rights reserved. | {SITE_DOMAIN}</p>
        <p className="footer__disclaimer">
          {FOOTER_DISCLAIMER} Operated by {COMPANY_NAME}, {ADDRESS}.
        </p>
      </div>
    </footer>
  );
}
